import type { IAccountTransaction } from "./types"

export function serializeAccountTransactions(data: IAccountTransaction[]) {
  return data.map((transaction) => {
    const accountNumber =
      transaction.account_number +
      (transaction.old_account_number
        ? ` (Old account number: ${transaction.old_account_number})`
        : "")

    return {
      ...transaction,
      utility_name:
        transaction.sender_utility?.utility_name ||
        transaction.receiver_utility?.utility_name,
      account_number: accountNumber,
    }
  })
}
